<template>
  <!-- 课程详情页页 -->
  <div>
    <div class="preview_box" ref="previewBox" v-if="isShelves">
      <div class="preview_top">
        <div class="top_box">
          <img v-lazy="$global.imgUrl + details.cover" class="cover" alt="" />
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            "
          >
            <h2 class="title" v-html="details.title"></h2>
            <div class="time">
              <span
                style="margin-right: 38px; cursor: pointer"
                @click="toUser(details.userType)"
                >{{ details.publisher }}</span
              >
              <span
                >发布时间：{{
                  details.auditStatusTime
                    ? details.auditStatusTime.slice(0, 10)
                    : ""
                }}</span
              >
            </div>
            <p class="price">
              {{ details.saleType == 1 ? "¥" + details.salePrice : "免费" }}
            </p>
            <div>
              <Button class="btn" @click="toSign(details.urlAddr)"
                >立即报名</Button
              >
              <span class="icon_span" @click="toCollect(details.id)"
                ><img
                  :src="
                    isCollect
                      ? require('@/assets/img/details/courseIsCollect.png')
                      : require('@/assets/img/details/courseCollect.png')
                  "
                  alt=""
                  class="top_icon"
                /><span class="share">收藏</span></span
              >
              <span class="icon_span share_span">
                <img
                  src="@/assets/img/details/courseshare.png"
                  alt=""
                  class="top_icon"
                />
                <span class="share">分享</span>
                <ul class="share_box">
                  <div class="sanjiao"></div>
                  <li @mouseover.stop="weChat" class="weChat">
                    <img src="@/assets/img/details/WeChat.png" alt />
                    <div>微信</div>
                    <div id="WXqrcode" ref="WXqrcode" class="ma"></div>
                  </li>
                  <li @click="weibo">
                    <img src="@/assets/img/details/weiBo.png" alt />
                    <div>新浪微博</div>
                  </li>
                  <li @mouseover.stop="qq" class="qq">
                    <img src="@/assets/img/details/QQ.png" alt />
                    <div>QQ</div>
                    <div id="QQqrcode" ref="QQqrcode" class="ma"></div>
                  </li>
                  <li @click="space">
                    <img src="@/assets/img/details/qqspace.png" alt />
                    <div>QQ空间</div>
                  </li>
                </ul>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="preview_content" v-html="details.content"></div>
    </div>
    <div id="concentration" v-else>
      <Shelves />
    </div>
  </div>
</template>
  
  <script>
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
import {changeTitle} from "@/utils/brower.js";
import Shelves from "../components/shelves";
export default {
  computed: {
    ...mapState(["hasLogin"]),
  },
  components: { Shelves },
  data() {
    return {
      details: {},
      isCollect: false,
      isShelves: true,
      WXurl: "",
      QQurl: "",
    };
  },
  created() {
    this.getDetails();
    if (this.hasLogin) {
      this.TFCollect();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$root.$el.style.backgroundColor = "#fafafa";
    });
  },
  methods: {
    // 获取详情
    async getDetails() {
      const resp = await this.$apis.recomendServe.getDetails({
        articleId: this.$router.history.current.query.id,
        articleType: this.$router.history.current.query.type,
      });
      if (resp.resultCode == 200) {
        this.details = resp.data.data;
        changeTitle(this.$global.matchReg(this.details.title))
      } else if (resp.resultCode === "10401002" || res.resultCode === "10401001") {
        this.isShelves = false
      }
    },
    // 跳转报名
    toSign(url) {
      window.open(url, "_blank");
    },
    // 点击收藏
    toCollect(id) {
      this.$preventFun.Debounce(async () => {
        if (!this.hasLogin) {
          this.$bus.$emit("showModel", true);
          return;
        }
        await this.$apis.recomendServe.CollectItem({
          action: this.isCollect ? 0 : 1,
          articleId: id,
          articleType: 9,
        });
        await this.TFCollect();
      })();
    },
    // 判断是否收藏
    async TFCollect() {
      let res = await this.$apis.recomendServe.isCollect({
        articleId: this.$router.history.current.query.id,
        articleType: 9,
      });
      this.isCollect = res.isCollect;
    },
    // 跳转用户详情
    toUser(type) {
      let routeUrl;
      switch (type) {
        case 0:
          routeUrl = this.$router.resolve({
            path: `/bjzxdetail`,
            query: {
              title: "百家在线",
              id: this.details.createUser,
            },
          });
          break;
        case 1:
          routeUrl = this.$router.resolve({
            path: `/bkzxdetail`,
            query: {
              title: "百科在线",
              id: this.details.companyId,
            },
          });
          break;
        case 2:
          routeUrl = this.$router.resolve({
            path: `/jghdetail`,
            query: {
              title: "机构号",
              id: this.details.companyId,
            },
          });
          break;
      }
      window.open(routeUrl.href, "_blank");
    },
    // 分享相关接口
    getUrl() {
      return this.$global.url1 + `courseDetails?id=${this.details.id}&type=9`;
    },
    weChat() {
      if (this.WXurl !== "") return;
      this.WXurl = this.getUrl();
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.WXcrateQrcode();
      });
    },
    WXcrateQrcode() {
      this.qr = new QRCode("WXqrcode", {
        width: 150,
        height: 150, // 高度
        text: this.WXurl, // 二维码内容
      });
    },
    QQcrateQrcode() {
      this.qr = new QRCode("QQqrcode", {
        width: 150,
        height: 150, // 高度
        text: this.QQurl, // 二维码内容
      });
    },
    qq() {
      if (this.QQurl !== "") return;
      this.QQurl = this.getUrl();

      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.QQcrateQrcode();
      });
    },
    weibo() {
      let url = encodeURIComponent(this.getUrl(true));
      let srcUrl = "";
      let srcTitle = "";
      this.details && this.details.cover
        ? (srcUrl = `pic=${this.$global.imgUrl + this.details.cover}&`)
        : (srcUrl = "");
      this.details && this.details.title
        ? (srcTitle = `&title=${this.details.title}`)
        : (srcTitle = "");
      window.open(
        `https://service.weibo.com/share/share.php?${srcUrl}url=${url}${srcTitle}&ralateUid=7679917329`
      );
    },
    space() {
      let url = encodeURIComponent(this.getUrl(true));
      let srcUrl = "";
      let srcTitle = "";
      this.details && this.details.cover
        ? (srcUrl = `pics=${this.$global.imgUrl + this.details.cover}&`)
        : (srcUrl = "");
      this.details && this.details.title
        ? (srcTitle = `&title=${this.details.title}`)
        : (srcTitle = "");
      window.open(
        `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?${srcUrl}url=${url}${srcTitle}`
      );
    },
  },
};
</script>
  
<style scoped lang="scss">
.preview_box {
  .preview_top {
    position: absolute;
    left: 0;
    top: 105px;
    margin-bottom: 20px;
    width: 100%;
    height: 288px;
    background: #ffffff;
    .top_box {
      display: flex;
      margin: 0 auto;
      padding-top: 37px;
      width: 1200px;
      .cover {
        margin-right: 30px;
        width: 380px;
        height: 214px;
      }
      .title {
        font-size: 24px;
        color: #333333;
        line-height: 33px;
      }
      .time {
        font-size: 14px;
        color: #666666;
        line-height: 17px;
      }
      .price {
        font-size: 24px;
        color: #ff0000;
        font-weight: 700;
        line-height: 20px;
      }
      .btn {
        width: 130px;
        height: 46px;
        background: #0b35c5;
        border-radius: 10px;
        font-size: 16px;
        color: #ffffff;
      }
      .share {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        vertical-align: middle;
        cursor: pointer;
      }
      .icon_span {
        margin-left: 30px;
        .top_icon {
          margin-right: 3px;
          vertical-align: middle;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
      }
      .share_span:hover {
        .share_box {
          display: block;
        }
      }
      .share_span {
        z-index: 10;
        position: relative;

        .share_box {
          display: none;
          position: absolute;
          left: 0;
          top: 20px;
          width: 133px;
          height: 167px;
          cursor: pointer;
          background: #ffffff;
          box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
          border-radius: 10px;

          .weChat:hover {
            .ma {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }

          .weChat {
            position: relative;

            .ma {
              display: none;
              left: 123px !important;
              position: absolute !important;
              width: 200px !important;
              top: -10px !important;
              height: 167px !important;
              background: white !important;
              box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
              border-radius: 10px;
            }
          }

          .qq:hover {
            .ma {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }

          .qq {
            position: relative;

            .ma {
              display: none;
              left: 123px !important;
              position: absolute !important;
              width: 200px !important;
              top: -90px !important;
              height: 167px !important;
              background: white !important;
              box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
              border-radius: 10px;
            }
          }

          li {
            display: flex;
            margin-top: 10px;
            margin-bottom: 0px;
            //display: flex;
            flex-wrap: nowrap;
            //background: pink;
            justify-content: center;
            align-items: center;
            width: 133px;
            height: 30px;

            div {
              width: 60px;
              //background: yellow;
              margin-left: 10px;
            }

            img {
              width: 20px;
              height: 20px;
            }
          }

          .sanjiao {
            width: 0;
            height: 0;
            border-top: 3px solid transparent;
            border-right: 6px solid #fff;
            position: absolute;
            top: 50%;
            margin-top: -3px;
            left: -6px;
            border-bottom: 3px solid transparent;

            //background: pink;
          }
        }
      }
    }
  }
  .preview_content {
    margin-top: 273px;
    padding: 10px;
    min-height: 300px;
    background: #ffffff;
    border-radius: 10px;
      &::v-deep img {
        max-width: 100%;
      }
  }
}
</style>